import { render, staticRenderFns } from "./AppTab.vue?vue&type=template&id=cf3e391c&scoped=true&"
import script from "./AppTab.vue?vue&type=script&lang=js&"
export * from "./AppTab.vue?vue&type=script&lang=js&"
import style0 from "./AppTab.vue?vue&type=style&index=0&id=cf3e391c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3e391c",
  null
  
)

export default component.exports